module.exports = "/assets/logo_sg_adobeaero-82aea25650850622ce0389e9e0f07e68.png";